module.exports = __webpack_public_path__ + "img/aeroland-clinic-image-02.2c54b7af.png";